import { Card, CardActionArea, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import type { UsersListFilter } from "@/components/UserManagement/types";
import type { IOrgUser } from "@/types";

interface OrganizationAccessCardsProps {
  currentTabUsers: IOrgUser[];
  adminCount: IOrgUser[];
  noAppAccess: IOrgUser[];
  activeFilter: UsersListFilter | null;
  /** `null` shows every user in the current tab. */
  onSelectFilter: (filter: UsersListFilter | null) => void;
}

export default function OrganizationAccessCards(
  props: OrganizationAccessCardsProps,
) {
  const { t } = useTranslation("common");
  const cards: {
    filter: UsersListFilter | null;
    count: number;
    labelKey: string;
  }[] = [
    {
      filter: null,
      count: props.currentTabUsers.length,
      labelKey: "userManagement.accessOverview.users",
    },
    {
      filter: { kind: "admins" },
      count: props.adminCount.length,
      labelKey: "userManagement.accessOverview.administrators",
    },
    {
      filter: { kind: "noAppAccess" },
      count: props.noAppAccess.length,
      labelKey: "userManagement.accessOverview.withoutAppAccess",
    },
  ];

  return (
    <div className="cards">
      {cards.map(({ filter, count, labelKey }) => {
        const isSelected = props.activeFilter?.kind === filter?.kind;

        return (
          <Card
            key={labelKey}
            variant="outlined"
            sx={{
              width: "fit-content",
              mt: "8px",
              mr: "6px",
              pr: "8px",
              borderColor: isSelected ? "primary.main" : undefined,
            }}
          >
            <CardActionArea
              onClick={() => props.onSelectFilter(filter)}
              aria-pressed={isSelected}
              sx={{
                display: "flex",
                flexDirection: "row",
                width: "110%",
                pr: "10px",
                pl: "6px",
              }}
            >
              <Typography
                sx={{
                  fontWeight: "bold",
                  fontSize: "1.5rem",
                  mr: "8px",
                  pt: "5px",
                  pb: "5px",
                }}
              >
                {count}
              </Typography>
              <Typography
                sx={{
                  color: "text.secondary",
                  fontSize: "0.85rem",
                  pt: "0.45rem",
                }}
              >
                {t(labelKey)}
              </Typography>
            </CardActionArea>
          </Card>
        );
      })}
    </div>
  );
}
